module.exports = "<h1>Server Error</h1>\n<h2>Sorry, server goes wrong</h2>\n<p>We track these errors automatically, but if the problem persists feel free to\n  <a href=\"mailto:support@tig.com?Subject=Server%20Error\" target=\"_top\">Contact us</a>\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/error-pages/page-500/page-500.component.html
// module id = ./src/app/error-pages/page-500/page-500.component.html
// module chunks = main